
import Vue from 'vue';

import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbContainer, mdbCard, mdbBtn, mdbRow, mdbCol, mdbCardUp, mdbCardAvatar, mdbCardBody, mdbCardTitle, mdbIcon, mdbInput } from 'mdbvue';
import navbar from '@/components/navbar.vue';
import mainFooter from '@/components/main-footer.vue';
import router from '../router'
import store from '../store';

export default Vue.extend({
  name: 'Home',
  data: function() {
    return {
      name: '',
      modal: false
    }
  },
  mounted() {
    // this.$refs.name.$el.focus();
  },
  methods: {
    goToCities: function() {
        if ( this.name && this.name != '' ) {
          store.commit('SET_NAME', this.name);
          router.push('/cities');
        } else {
          this.modal = true;
        }
    }
  },
  components: {
    mdbContainer,
    mdbCard, 
    mdbBtn,
    navbar,
    mainFooter,
    mdbRow,
    mdbCol,
    mdbCardUp, 
    mdbCardAvatar, 
    mdbCardBody, 
    mdbCardTitle, 
    mdbIcon,
    mdbInput,
    mdbModal, 
    mdbModalHeader, 
    mdbModalTitle,
    mdbModalBody, 
    mdbModalFooter
  },
});
